// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__uGP_2","content":"style_content__5Pz5N","texts":"style_texts___bVMn","title":"style_title__fyhWA","logo":"style_logo__AhHXF","button":"style_button__3HzNa"};